import Vue from "vue";
import VueRouter from "vue-router";
import App from "@/App";
import Home from "@/views/Home";
import Messaging from "@/views/Messaging";
import Messages from "@/views/Messages";
import ViewMessage from "@/components/ViewMessage";
import ManageUser from "@/views/ManageUser";
import AddUser from "@/views/AddUser";
import EditUser from "@/views/EditUser";
import ManageRole from "@/views/ManageRole";
import AddRole from "@/views/AddRole";
import EditRole from "@/views/EditRole";
import ManageGroup from "@/views/ManageGroup";
import ManageLocation from "@/views/ManageLocation";
import AttendanceView from "@/views/AttendanceView";
import Login from "@/components/Login";
import EditGroup from "@/views/EditGroup";
import AddGroup from "@/views/AddGroup";
import ViewGroup from "@/views/ViewGroup";
import AddLocation from "@/views/AddLocation";
import EditLocation from "@/views/EditLocation";
import ParentView from "@/views/ParentView";
import StudentView from "@/views/StudentView";
import StudentActivityInfo from "@/views/StudentActivityInfo";
import StudentProfile from "@/views/StudentProfile";
import VendorView from "@/views/VendorView";
import StaffView from "@/views/StaffView";
import StaffAttendance from "@/components/StaffAttendance";
import VendorAttendance from "@/views/VendorAttendance";
import TransporterView from "@/views/TransporterView";
import CCAProposalSetting from "@/components/CCAProposalSetting";
import CCAProposal from "@/views/CCAProposal";
import CCAProposalForm from "@/components/CCAProposalForm";
import ManageProposal from "@/views/ManageProposal";
import EditProposal from "@/views/EditProposal";
import CCALog from "@/views/CCALog";
import AppSetting from "@/views/AppSetting";
import TermYearSetting from "@/components/TermYearSetting";
import CCAScheduleSetting from "@/components/CCAScheduleSetting";
import CCADefaultSetting from "@/components/CCADefaultSetting";
import PublicHolidaySetting from "@/components/PublicHolidaySetting";
import DefaultMessageSetting from "@/components/DefaultMessageSetting";
import EditDefaultMessage from "@/views/EditDefaultMessage";
import StatisticView from "@/views/StatisticView";
import ParticipantListView from "@/views/ParticipantListView";
import NotFound from "@/views/NotFound";
import UnderMaintenance from "@/views/UnderMaintenance";
import StaticSignOut from "@/views/StaticSignOut";

Vue.use(VueRouter);

const routes = [
   {
      path: "/",
      name: "App",
      component: App,
      // redirect: "/Login",
   },
   {
      path: "/Home",
      name: "Home",
      component: Home,
   },
   {
      path: "/Messaging",
      name: "Messaging",
      component: Messaging,
   },
   {
      path: "/Messages",
      name: "Messages",
      component: Messages,
   },
   {
      path: "/ViewMessage/:msg",
      name: "ViewMessage",
      component: ViewMessage,
      props: true,
   },
   {
      path: "/ManageUser",
      name: "ManageUser",
      component: ManageUser,
   },
   {
      path: "/AddUser",
      name: "AddUser",
      component: AddUser,
   },
   {
      path: "/EditUser/:userid",
      name: "EditUser",
      component: EditUser,
   },
   {
      path: "/ManageRole",
      name: "ManageRole",
      component: ManageRole,
   },
   {
      path: "/AddRole",
      name: "AddRole",
      component: AddRole,
   },
   {
      path: "/EditRole/:role_id",
      name: "EditRole",
      component: EditRole,
   },
   {
      path: "/ManageGroup",
      name: "ManageGroup",
      component: ManageGroup,
   },
   {
      path: "/AddGroup",
      name: "AddGroup",
      component: AddGroup,
   },
   {
      path: "/EditGroup/:groupid",
      name: "EditGroup",
      component: EditGroup,
   },
   {
      path: "/ManageLocation",
      name: "ManageLocation",
      component: ManageLocation,
   },
   {
      path: "/AddLocation",
      name: "AddLocation",
      component: AddLocation,
   },
   {
      path: "/EditLocation/:locationid",
      name: "EditLocation",
      component: EditLocation,
   },
   {
      path: "/AttendanceView/:eventid",
      name: "AttendanceView",
      component: AttendanceView,
      props: true,
   },
   {
      path: "/StaffView",
      name: "StaffView",
      component: StaffView,
   },
   {
      path: "/ViewGroup/:groupid",
      name: "ViewGroup",
      component: ViewGroup,
   },
   {
      path: "/StaffAttendance",
      name: "StaffAttendance",
      component: StaffAttendance,
      props: true,
   },
   {
      path: "/ParentView",
      name: "ParentView",
      component: ParentView,
   },
   {
      path: "/StudentView",
      name: "StudentView",
      component: StudentView,
   },
   {
      path: "/StudentActivityInfo",
      name: "StudentActivityInfo",
      component: StudentActivityInfo,
   },
   {
      path: "/StudentProfile",
      name: "StudentProfile",
      component: StudentProfile,
   },
   {
      path: "/VendorView",
      name: "VendorView",
      component: VendorView,
   },
   {
      path: "/TransporterView",
      name: "TransporterView",
      component: TransporterView,
   },
   {
      path: "/VendorAttendance",
      name: "VendorAttendance",
      component: VendorAttendance,
   },
   {
      path: "/CCAProposalSetting",
      name: "CCAProposalSetting",
      component: CCAProposalSetting,
   },
   {
      path: "/CCAProposal",
      name: "CCAProposal",
      component: CCAProposal,
   },
   {
      path: "/CCAProposalForm",
      name: "CCAProposalForm",
      component: CCAProposalForm,
   },
   {
      path: "/ManageProposal",
      name: "ManageProposal",
      component: ManageProposal,
   },
   {
      path: "/EditProposal/:proposalid",
      name: "EditProposal",
      component: EditProposal,
   },
   {
      path: "/CCALog",
      name: "CCALog",
      component: CCALog,
   },
   {
      path: "/AppSetting",
      name: "AppSetting",
      component: AppSetting,
   },
   {
      path: "/TermYearSetting",
      name: "TermYearSetting",
      component: TermYearSetting,
   },
   {
      path: "/CCAScheduleSetting",
      name: "CCAScheduleSetting",
      component: CCAScheduleSetting,
   },
   {
      path: "/CCADefaultSetting",
      name: "CCADefaultSetting",
      component: CCADefaultSetting,
   },
   {
      path: "/PublicHolidaySetting",
      name: "PublicHolidaySetting",
      component: PublicHolidaySetting,
   },
   {
      path: "/DefaultMessageSetting",
      name: "DefaultMessageSetting",
      component: DefaultMessageSetting,
   },
   {
      path: "/EditDefaultMessage/:message",
      name: "EditDefaultMessage",
      component: EditDefaultMessage,
   },
   {
      path: "/StatisticView",
      name: "StatisticView",
      component: StatisticView,
   },
   {
      path: "/ParticipantListView",
      name: "ParticipantListView",
      component: ParticipantListView,
   },
   {
      path: "/Login",
      name: "Login",
      component: Login,
   },
   {
      path: "/NotFound",
      name: "NotFound",
      component: NotFound,
   },
   {
      path: "/UnderMaintenance",
      name: "UnderMaintenance",
      component: UnderMaintenance,
   },
   {
      path: "/StaticSignOut",
      name: "StaticSignOut",
      component: StaticSignOut,
   },
   {
      path: "/:pathMatch(.*)*",
      component: Login,
   },
   // {
   //    path: '/about',
   //    name: 'About',
   //    // route level code-splitting
   //    // this generates a separate chunk (about.[hash].js) for this route
   //    // which is lazy-loaded when the route is visited.
   //    component: () =>
   //       import(/* webpackChunkName: "about" */ '../views/testform.vue'),
   // },
];

const router = new VueRouter({
   routes,
   mode: "history",
});

router.beforeEach((to, from, next) => {
   const mystore = Vue.prototype.$globalstore;

   const sso = to.query.sso;

   const saml = to.query.saml;

   // console.log("from: ", from, " to: ", to);

   if (from.name === null && to.name === "Login" && sso) {
      next({query: to.query.sso});
   } else if (to.name === "Login" && saml) {
      // console.log("saml branch");
      localStorage.removeItem("usertoken");
      next({query: to.query.saml});
   } else if (from.name == null && to.path === "/") {
      // console.log("from null to / branch");
      next();
   } else if (to.name === "Login" && mystore.user.tokenexpired) {
      //console.log("token expired branch");
      mystore.LogOutAndResetUser();
      next();
   } else if (to.name === "Login" && mystore.user.isLoggedIn && !mystore.user.tokenexpired) {
      // console.log("user already logged in branch ", mystore.user);
      // next(false);
      return false;
   } else if (to.name === "Home" && !mystore.user.isLoggedIn) {
      // console.log(" user not logged in branch");
      next({name: "Login"});
   } else if (to.name === "Login" && from.name === "Login") {
      // console.log("same route");
      return false;
   } else {
      if (to.name !== from.name && to.path !== from.path) {
         next();
      }
   }
});

export default router;
